var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex fd-column h-100"},[_c('app-header',{staticClass:"flex-0-0 x-print-hide",attrs:{"header-options":_vm.headerOptions}}),_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('router-view',{staticClass:"x-main-route"})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }